import { MdDelete } from 'react-icons/md';
function CustomTable({ data, getContentDataHandler }) {
  const handleDelete = async (data) => {
    getContentDataHandler(data);
  };
  const imageStyles = {
    width: '100px',
    maxHeight: '200px',
  };

  return (
    <>
      {data?.length !== 0 && (
        <div className='table'>
          <table className='my-table'>
            <thead>
              <tr>
                <th>Images</th>

                <th>Delete</th>
              </tr>
            </thead>

            <tbody>
              {data?.map((items, indx) => (
                <tr key={indx}>
                  <td>
                    <img
                      src={
                        items?.menu
                        //  typeof items === 'string' && /^https?:\/\//.test(items.img_url)
                      }
                      //maxHeigth={100}
                      maxWidth={100}
                      alt={''}
                      crossOrigin='anonymous'
                      style={imageStyles}
                    />
                  </td>

                  <td>
                    <div
                      style={{ display: 'flex', columnGap: '5px' }}
                      className='table-menu'
                    >
                      <MdDelete
                        onClick={() => {
                          handleDelete(items);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export default CustomTable;
